import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 发起费用解锁申请(校验+快照+企微审批)
// data: { jobUuids: string[], reason: string, declaredProfitImpact: number }
// 校验失败(590505)返回完整错误以便前端逐单展示失败原因
export function applyUnlockApply(data) {
  return request({
    url: URL.booking.unlockApply.apply,
    method: 'post',
    data,
    // 返回完整错误，便于前端定位问题
    fullError: true,
    // 错误由弹窗统一展示(含逐单失败原因)，公共层不重复弹错
    forbidAlert: true
  })
}

// 解锁申请台账分页查询
// params: { batchNo, applyUser, status, pageNum, pageSize }
export function pageUnlockApply(params) {
  return request({
    url: URL.booking.unlockApply.page,
    method: 'get',
    params
  })
}
